export default "__VITE_ASSET__DkvQjwfy__"